<div class="css-card-editor bootstrap5-wrapper">
  <div id="controls" style="display: block">
    <div class="toolbar toolbar-top">
      <div class="logo">
        <a href="/"
          ><img
            src="https://pub-f79427c950a84405a07a8998dcded99f.r2.dev/assets/images/247invites-logo.png"
            alt="Logo"
        /></a>
      </div>
      <div class="toolbar-options">
        <button (click)="addText()" class="btn-top-bar">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M12 3h4.218C19.166 3 21 5.08 21 8.026v7.948C21 18.919 19.166 21 16.217 21H7.783C4.835 21 3 18.919 3 15.974V12m5.293-2.415V8.269h7.414v1.316m-3.742-1.316v7.462m-1.618 0h3.307M4.7 2.436v4.49M6.944 4.68h-4.49"
            ></path>
          </svg>
          Text
        </button>

        <button class="btn-top-bar py-0">
          <label
            class="mb-0 d-flex gap-2 align-items-center"
            style="height: 42px"
            for="addImage"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="m20.996 15.572-3.95-2.866a3.86 3.86 0 0 0-4.816.224l-7.694 6.903M3 15.474c.839-.77 2.145-1.999 3.92-1.043a28 28 0 0 1 2.174 1.316M4.7 2.436v4.49M6.944 4.68h-4.49M12.001 3h4.217C19.166 3 21 5.08 21 8.026v7.948C21 18.919 19.166 21 16.217 21H7.783C4.835 21 3 18.919 3 15.974V12"
              ></path>
            </svg>
            Image
          </label>
          <input
            type="file"
            hidden
            (change)="addImageToCanvas($event)"
            accept="image/*"
            id="addImage"
          />
        </button>

        <select
          (change)="loadLanguageElements($event)"
          id="language-selector"
          *ngIf="isAdmin"
        >
          <option *ngFor="let lang of languages" [value]="lang">
            {{ lang }}
          </option>
        </select>

        <label for="background-upload" *ngIf="isAdmin">Upload Background</label>
        <input
          id="background-upload"
          type="file"
          accept="image/*"
          (change)="onBackgroundUpload($event)"
          *ngIf="isAdmin"
        />

        <label for="photo-upload" *ngIf="isAdmin">Upload Photo</label>
        <input
          id="photo-upload"
          type="file"
          accept="image/*"
          (change)="onPhotoUpload($event)"
          *ngIf="isAdmin"
        />

        <button (click)="addPlacementMarker()" *ngIf="isAdmin">
          Add Placement Marker
        </button>
        <p *ngIf="markerCoordinates && isAdmin">
          Marker Coordinates: {{ markerCoordinates.x }},
          {{ markerCoordinates.y }}
        </p>

        <label for="colorPicker" *ngIf="isAdmin">Hover Theme:</label>
        <input
          id="colorPicker"
          type="color"
          *ngIf="isAdmin"
          (input)="onColorSelected($event)"
        />
      </div>

      <div class="action-buttons">
        <button
          (click)="saveTemplate()"
          class="btn-save-draft"
          id="save-button"
          *ngIf="isAdmin"
        >
          Save Template
        </button>
        <button
          (click)="saveDraft()"
          *ngIf="!isAdmin"
          class="btn-save-draft"
          id="save-button"
        >
          Save Draft
        </button>

        <button
          (click)="saveJSON()"
          class="btn-save-draft"
          *ngIf="isAdmin"
          id="save-button"
        >
          Save draft
        </button>
        <div class="dropdown">
          <button class="dropdown-btn btn-save" (click)="toggleDropdown()">
            Next
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              preserveAspectRatio="xMidYMid"
              viewBox="0 0 24 24"
              class="icon duration-100 w-4 h-4"
            >
              <path
                stroke="#fff"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="m9 6 6 6-6 6"
              ></path>
            </svg>
          </button>
          <div
            class="dropdown-content"
            [@dropdownAnimation]="isDropdownOpen ? 'open' : 'closed'"
            *ngIf="isDropdownOpen"
          >
            <button
              (click)="openWatermarkPopup(); toggleDropdown()"
              class="finish-item-button text-body-bold"
              aria-label="Download image"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                fill="none"
                class="finish-item-icon"
              >
                <path
                  stroke="#20282d"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  d="M17.056 9.592V3.5m2.408 3.676-2.408 2.418-2.408-2.418M3.004 16.08l3.95-2.867a3.86 3.86 0 0 1 4.815.225l7.694 6.903m1.535-4.359c-.838-.77-2.145-1.999-3.92-1.043a28 28 0 0 0-2.174 1.316M21 11.458v5.022c0 2.945-1.843 5.022-4.788 5.022H7.778C4.833 21.502 3 19.425 3 16.48V8.533c0-2.945 1.843-5.021 4.778-5.021h3.56"
                ></path>
              </svg>
              <div class="title">Download image</div>
            </button>

            <button
              (click)="downloadPaid(); toggleDropdown()"
              class="finish-item-button text-body-bold"
              aria-label="Download image"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                fill="none"
                class="finish-item-icon"
              >
                <path
                  stroke="#20282d"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  d="M17.056 9.592V3.5m2.408 3.676-2.408 2.418-2.408-2.418M3.004 16.08l3.95-2.867a3.86 3.86 0 0 1 4.815.225l7.694 6.903m1.535-4.359c-.838-.77-2.145-1.999-3.92-1.043a28 28 0 0 0-2.174 1.316M21 11.458v5.022c0 2.945-1.843 5.022-4.788 5.022H7.778C4.833 21.502 3 19.425 3 16.48V8.533c0-2.945 1.843-5.021 4.778-5.021h3.56"
                ></path>
              </svg>
              <div class="title">Download Paid</div>
            </button>

            <button
              (onclick)="downloadAsPNG(); toggleDropdown()"
              class="finish-item-button text-body-bold"
              aria-label="Download PDF"
              *ngIf="isAdmin"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                fill="none"
                class="finish-item-icon"
              >
                <path
                  stroke="#20282d"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  d="M19.831 13.452V9.66c0-.544-.21-1.067-.586-1.459L15.35 4.147a2.1 2.1 0 0 0-1.519-.647H8.03a3.847 3.847 0 0 0-3.861 3.756v6.196m10.16-9.89v2.97a2.63 2.63 0 0 0 2.623 2.63h2.813M4.416 19.972h1.397a1.547 1.547 0 0 0 0-3.093H4.416v4.615m15.414-4.619h-2.506v4.626m2.12-1.927h-2.12m-5.67 1.927a2.313 2.313 0 0 0 0-4.626h-1.156v4.626z"
                ></path>
              </svg>
              <div class="title">Download PDF</div>
            </button>
            <button
              (onclick)="toggleDropdown()"
              class="finish-item-button text-body-bold"
              aria-label="Share"
              *ngIf="isAdmin"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                fill="none"
                class="finish-item-icon"
              >
                <path
                  stroke="#20282d"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  d="m8.93 13.858 6.148 3.583m-.01-9.882L8.93 11.14M17.4 3.5a2.7 2.7 0 1 1 .001 5.399A2.7 2.7 0 0 1 17.4 3.5M6.6 9.8a2.7 2.7 0 1 1 .001 5.398 2.7 2.7 0 0 1 0-5.398m10.8 6.3A2.7 2.7 0 1 1 17.4 21.5 2.7 2.7 0 0 1 17.4 16.1"
                ></path>
              </svg>

              <div class="title">Share</div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div style="min-height: 54px; background: #e9e9ea" class="desktop-toolbar"> 
      <div id="text-controls" class="toolbar toolbar-bottom">
        <div class="text-controls">
          <select
            #fontSelect
            (change)="onFontChange($event)"
            [style.fontFamily]="selectedFont"
            [value]="selectedFont"
            *ngIf="canvasService.isTextBoxSelected"
          >
            <option
              *ngFor="let font of fontList"
              [value]="font"
              [style.fontFamily]="font"
            >
              {{ font }}
            </option>
          </select>

          <select
            style="min-width: 90px"
            class="select-dropdown"
            id="font-size-selector"
            [(ngModel)]="selectedFontSize"
            (change)="onFontSizeChange($event)"
          >
            <option *ngFor="let size of fontSizes" [value]="size">
              {{ size }}
            </option>
          </select>

          <div style="width: 30px; height: 30px; border-radius: 50%">
            <input
              type="color"
              id="text-color"
              [(ngModel)]="selectedColor"
              [value]="defaultTextColor"
              (input)="updateTextboxColor($event)"
              style="
                width: 30px;
                height: 30px;
                border: none;
                padding: 8px;
                cursor: pointer;
                border-radius: 50px;
                display: block;
              "
            />
          </div>

          <button
            id="bold-button"
            class="btn-decor"
            [ngClass]="{ 'btn-active': isBoldActive }"
            (click)="toggleBold()"
          >
          <svg data-v-f59ed494="" xmlns="http://www.w3.org/2000/svg" fill="none" preserveAspectRatio="xMidYMid" viewBox="0 0 24 24" class="icon"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M8.025 12h4.431c1.945 0 3.5-1.67 3.311-3.654-.165-1.73-1.716-3-3.454-3H8.025zm0 0h5.48c1.737 0 3.289 1.27 3.454 3a3.33 3.33 0 0 1-3.31 3.653H8.024z"></path></svg>
          </button>

          <button
            id="italic-button"
            class="btn-decor"
            [ngClass]="{ 'btn-active': isItalicActive }"
            (click)="toggleItalic()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              preserveAspectRatio="xMidYMid"
              viewBox="0.5 0.5 24 24"
              class="icon"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M14 19.766h-3m0 0H8m3 0 4-14m3 0h-3m0 0h-3"
              ></path>
            </svg>
          </button>

          <button
            id="align-left"
            class="btn-decor"
            [ngClass]="{ 'btn-active': activeTextButton === 'left' }"
            (click)="alignText('left')"
          >
          <svg data-v-a4392f82="" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" class="icon"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4 12h8M4 5h16M4 19h16"></path></svg>
          </button>

          <button
            id="align-center"
            [ngClass]="{ 'btn-active': activeTextButton === 'center' }"
            class="btn-decor"
            (click)="alignText('center')"
          >
          <svg data-v-a4392f82="" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" class="icon"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M20 19H4M20 5H4m12 7H8"></path></svg>
          </button>

          <button
            id="align-right"
            class="btn-decor"
            [ngClass]="{ 'btn-active': activeTextButton === 'right' }"
            (click)="alignText('right')"
          >
          <svg data-v-a4392f82="" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" class="icon"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M20 19H4M20 5H4m16 7h-8"></path></svg>
          </button>

          <!-- Line Height Dropdown -->
          <div class="form-group position-relative">
            <label
              for="lineHeightSelect"
              class="select-label position-absolute transition-all duration-200"
              *ngIf="isLabelVisible"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1.5rem"
                height="1.5rem"
                fill="none"
                class="icon"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  d="m4.5 8.22 2.835-2.835m0 0L10.17 8.22M7.335 5.385v13.23m0 0L4.5 15.78m2.835 2.835 2.835-2.835m3.848-3.686H20.5m-6.483 5.708H20.5M14.018 6.193H20.5"
                ></path>
              </svg>
            </label>
            <select
              id="lineHeightSelect"
              class="form-control select-with-icon"
              [(ngModel)]="selectedLineHeight"
              (change)="onLineHeightChange($event)"
            >
              <option *ngFor="let height of lineHeights" [value]="height">
                {{ height }}
              </option>
            </select>
          </div>
          <!-- Line Height Button with Dropdown -->

          <!-- Line Height Button with Dropdown -->
          <button id="copy-format" class="btn-decor" (click)="copyTextboxFormatting()"  title="Copy Formatting">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" class="icon">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8 4v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2zm-4 2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2"></path>
            </svg>
          </button>

          <button id="paste-format" class="btn-decor" (click)="pasteTextboxFormatting()" title="Paste Formatting">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" class="icon">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2m-3 0V3m0 2h3"></path>
            </svg>
          </button>
          <button id="duplicate-textbox" class="btn-decor" (click)="duplicateTextbox()"  title="Duplicate Textbox">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" class="icon">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8 4v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2zm4 14v3m0 0h-3m3 0h3"></path>
            </svg>
          </button>

          <button (click)="deleteSelectedObject()" class="btn-decor">
            <svg
              data-v-c035fed1
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="none"
              class="icon"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="m18.9 9.645-.587 8.041a3.184 3.184 0 0 1-3.176 2.953H9.384a3.185 3.185 0 0 1-3.176-2.953l-.587-8.041m14.574-3.019H4.326m11.555 0-.483-2.378a1.2 1.2 0 0 0-1.157-.888h-3.957a1.2 1.2 0 0 0-1.162.888l-.479 2.377m1.795 5.165v4.328m3.245-4.328v4.328"
              ></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="toolbar-for-mobile">
    <div id="controls" style="display: block">
      <div class="toolbar toolbar-top">
        <div class="mobile-btn">
          <div [routerLink]="['/']">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 1 24 24"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="m15 6.601-6 6 6 6"
              ></path>
            </svg>
          </div>
          <!-- <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 2 24 24"
              class="icon">
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M7.053 12.29 4 9.238l3.053-3.053M4 9.238h10.857a5.143 5.143 0 0 1 0 10.286H6.42"></path>
            </svg>
          </div>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 2 24 24"
              class="icon">
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M16.946 12.29C18.14 11.1 18.807 10.43 20 9.238l-3.054-3.053M20 9.238H9.143a5.143 5.143 0 0 0 0 10.286h8.437"></path>
            </svg>
          </div> -->
        </div>
        <div class="action-buttons mobile-action-buttons">
          <button (click)="saveJSON()" class="btn-save-draft" id="save-button">
            Save draft
          </button>
          <div class="dropdown">
            <button
              class="dropdown-btn btn-save"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasBottom1"
              aria-controls="offcanvasBottom"
            >
              Next
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                preserveAspectRatio="xMidYMid"
                viewBox="0 0 24 24"
                class="icon duration-100 w-4 h-4"
              >
                <path
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  d="m9 6 6 6-6 6"
                ></path>
              </svg>
            </button>

            <div
              class="offcanvas offcanvas-bottom"
              tabindex="-1"
              id="offcanvasBottom1"
              aria-labelledby="offcanvasBottomLabel"
              aria-modal="true"
              role="dialog"
            >
              <div class="offcanvas-header">
                <button
                  type="button"
                  class="btn-close text-reset"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>
              <div class="offcanvas-body small">
                <button
                  (click)="onDownloadWithWatermark()"
                  data-bs-dismiss="offcanvas"
                  class="finish-item-button text-body-bold"
                  aria-label="Download image"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    fill="none"
                    class="finish-item-icon"
                  >
                    <path
                      stroke="#20282d"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M17.056 9.592V3.5m2.408 3.676-2.408 2.418-2.408-2.418M3.004 16.08l3.95-2.867a3.86 3.86 0 0 1 4.815.225l7.694 6.903m1.535-4.359c-.838-.77-2.145-1.999-3.92-1.043a28 28 0 0 0-2.174 1.316M21 11.458v5.022c0 2.945-1.843 5.022-4.788 5.022H7.778C4.833 21.502 3 19.425 3 16.48V8.533c0-2.945 1.843-5.021 4.778-5.021h3.56"
                    ></path>
                  </svg>
                  <div class="title">Download image</div>
                </button>
                <button
                  (click)="onDownloadPaid()"
                  class="finish-item-button text-body-bold"
                  aria-label="Download image"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    fill="none"
                    class="finish-item-icon"
                  >
                    <path
                      stroke="#20282d"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M17.056 9.592V3.5m2.408 3.676-2.408 2.418-2.408-2.418M3.004 16.08l3.95-2.867a3.86 3.86 0 0 1 4.815.225l7.694 6.903m1.535-4.359c-.838-.77-2.145-1.999-3.92-1.043a28 28 0 0 0-2.174 1.316M21 11.458v5.022c0 2.945-1.843 5.022-4.788 5.022H7.778C4.833 21.502 3 19.425 3 16.48V8.533c0-2.945 1.843-5.021 4.778-5.021h3.56"
                    ></path>
                  </svg>
                  <div class="title">Download Paid</div>
                </button>
                <button
                  (onclick)="downloadAsPNG()"
                  class="finish-item-button text-body-bold"
                  aria-label="Download PDF"
                  *ngIf="isAdmin"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    fill="none"
                    class="finish-item-icon"
                  >
                    <path
                      stroke="#20282d"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M19.831 13.452V9.66c0-.544-.21-1.067-.586-1.459L15.35 4.147a2.1 2.1 0 0 0-1.519-.647H8.03a3.847 3.847 0 0 0-3.861 3.756v6.196m10.16-9.89v2.97a2.63 2.63 0 0 0 2.623 2.63h2.813M4.416 19.972h1.397a1.547 1.547 0 0 0 0-3.093H4.416v4.615m15.414-4.619h-2.506v4.626m2.12-1.927h-2.12m-5.67 1.927a2.313 2.313 0 0 0 0-4.626h-1.156v4.626z"
                    ></path>
                  </svg>
                  <div class="title">Download PDF</div>
                </button>
                <button
                  class="finish-item-button text-body-bold"
                  aria-label="Share"
                  *ngIf="isAdmin"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    fill="none"
                    class="finish-item-icon"
                  >
                    <path
                      stroke="#20282d"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="m8.93 13.858 6.148 3.583m-.01-9.882L8.93 11.14M17.4 3.5a2.7 2.7 0 1 1 .001 5.399A2.7 2.7 0 0 1 17.4 3.5M6.6 9.8a2.7 2.7 0 1 1 .001 5.398 2.7 2.7 0 0 1 0-5.398m10.8 6.3A2.7 2.7 0 1 1 17.4 21.5 2.7 2.7 0 0 1 17.4 16.1"
                    ></path>
                  </svg>

                  <div class="title">Share</div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="main-bg">
    <div class="loader" *ngIf="isLoading">
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/3/3a/Gray_circles_rotate.gif"
        alt="Loading..."
        class="loader-image"
      />
    </div>
    <div id="canvas-container">
      <!-- <label for="image-uploader"  class="image-uploder-custom ">
          <svg
            data-v-e090da74=""
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            class="icon"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="m20.996 15.572-3.95-2.866a3.86 3.86 0 0 0-4.816.224l-7.694 6.903M3 15.474c.839-.77 2.145-1.999 3.92-1.043a28 28 0 0 1 2.174 1.316M4.7 2.436v4.49M6.944 4.68h-4.49M12.001 3h4.217C19.166 3 21 5.08 21 8.026v7.948C21 18.919 19.166 21 16.217 21H7.783C4.835 21 3 18.919 3 15.974V12"
            ></path>
          </svg>
          <span>Add Photo</span>
        </label> -->
      <input
        #fileInput
        style="position: absolute; opacity: 0"
        type="file"
        id="image-uploader"
        accept="image/*"
        (change)="uploadImage($event)"
      />
      <div
        style="cursor: pointer; display: flex; align-items: center; gap: 8px"
        (click)="fileInput.click()"
        id="image-uploader-image"
      >
        <svg
          data-v-e090da74
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          class="icon"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            d="m20.996 15.572-3.95-2.866a3.86 3.86 0 0 0-4.816.224l-7.694 6.903M3 15.474c.839-.77 2.145-1.999 3.92-1.043a28 28 0 0 1 2.174 1.316M4.7 2.436v4.49M6.944 4.68h-4.49M12.001 3h4.217C19.166 3 21 5.08 21 8.026v7.948C21 18.919 19.166 21 16.217 21H7.783C4.835 21 3 18.919 3 15.974V12"
          ></path>
        </svg>

        <span>Add Photo</span>
      </div>

      <!-- <div *ngIf="!isLoading"> -->
      <canvas id="canvas"></canvas>
      <!-- </div> -->
    </div>
  </div>

  <button
    *ngIf="duplicateButtonPosition.visible"
    class="duplicate-button-small"
    [style.left.px]="duplicateButtonPosition.left"
    [style.top.px]="duplicateButtonPosition.top"
    (click)="duplicateTextbox()"
    title="Duplicate Textbox"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" class="icon">
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8 4v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2zm4 14v3m0 0h-3m3 0h3"></path>
    </svg>
  </button>

  <button
    *ngIf="deleteButtonPosition.visible"
    class="delete-button-small"
    [style.left.px]="deleteButtonPosition.left"
    [style.top.px]="deleteButtonPosition.top"
    (click)="deleteSelectedObject()"
    title="Delete Textbox"
    aria-label="Delete Textbox"
  >
    🗑️
  </button>


  
  <div id="mobile-controls" class="mobile-bottom-toolbar">
    <div style="min-height: 59px">
      <div id="text-controls" class="toolbar toolbar-bottom">
        <div class="text-controls">
          <button (click)="deleteSelectedObject()" class="btn-decor">
            <svg
              data-v-c035fed1
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              fill="none"
              class="icon"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="m18.9 9.645-.587 8.041a3.184 3.184 0 0 1-3.176 2.953H9.384a3.185 3.185 0 0 1-3.176-2.953l-.587-8.041m14.574-3.019H4.326m11.555 0-.483-2.378a1.2 1.2 0 0 0-1.157-.888h-3.957a1.2 1.2 0 0 0-1.162.888l-.479 2.377m1.795 5.165v4.328m3.245-4.328v4.328"
              ></path>
            </svg>
          </button>
          <button
            class="btn-decor fw-700 whitespace-nowrap"
            (click)="openTextEditPopup()"
          >
            Edit Text
          </button>
          <select
            #fontSelect
            (change)="onFontChange($event)"
            [style.fontFamily]="selectedFont"
            [value]="selectedFont"
          >
            <option
              *ngFor="let font of fontList"
              [value]="font"
              [style.fontFamily]="font"
            >
              {{ font }}
            </option>
          </select>
          <select
            class="select-dropdown"
            id="font-size-selector"
            [(ngModel)]="selectedFontSize"
            (change)="onFontSizeChange($event)"
          >
            <option *ngFor="let size of fontSizes" [value]="size">
              {{ size }}
            </option>
          </select>
          <div class="form-group position-relative">
            <label
              for="lineHeightSelect"
              class="select-label position-absolute transition-all duration-200"
              *ngIf="isLabelVisible"
            >
            <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1.5rem"
            height="1.5rem"
            fill="none"
            class="icon"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="m4.5 8.22 2.835-2.835m0 0L10.17 8.22M7.335 5.385v13.23m0 0L4.5 15.78m2.835 2.835 2.835-2.835m3.848-3.686H20.5m-6.483 5.708H20.5M14.018 6.193H20.5"
            ></path>
          </svg>
            </label>
            <select
              id="lineHeightSelect"
              class="form-control select-with-icon"
              [(ngModel)]="selectedLineHeight"
              (change)="onLineHeightChange($event)"
            >
              <option *ngFor="let height of lineHeights" [value]="height">
                {{ height }}
              </option>
            </select>
          </div>
          <div style="width: 30px; height: 30px; border-radius: 50%">
            <input
              type="color"
              id="text-color"
              [(ngModel)]="selectedColor"
              [value]="defaultTextColor"
              (input)="updateTextboxColor($event)"
              style="
                width: 30px;
                height: 30px;
                border: none;
                padding: 8px;
                cursor: pointer;
                border-radius: 50px;
                display: block;
              "
            />
          </div>

          <button
            id="bold-button"
            class="btn-decor"
            [ngClass]="{ 'btn-active': isBoldActive }"
            (click)="toggleBold()"
          >
          <svg data-v-f59ed494="" xmlns="http://www.w3.org/2000/svg" fill="none" preserveAspectRatio="xMidYMid" viewBox="0 0 24 24" class="icon"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M8.025 12h4.431c1.945 0 3.5-1.67 3.311-3.654-.165-1.73-1.716-3-3.454-3H8.025zm0 0h5.48c1.737 0 3.289 1.27 3.454 3a3.33 3.33 0 0 1-3.31 3.653H8.024z"></path></svg>
          </button>

          <button
            id="italic-button"
            class="btn-decor"
            [ngClass]="{ 'btn-active': isItalicActive }"
            (click)="toggleItalic()"
          >
          <svg data-v-f59ed494="" xmlns="http://www.w3.org/2000/svg" fill="none" preserveAspectRatio="xMidYMid" viewBox="0.5 0.5 24 24" class="icon"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M14 19.766h-3m0 0H8m3 0 4-14m3 0h-3m0 0h-3"></path></svg>
          </button>

          <button
            id="align-left"
            class="btn-decor"
            [ngClass]="{ 'btn-active': activeTextButton === 'left' }"
            (click)="alignText('left')"
          >
          <svg data-v-a4392f82="" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" class="icon"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4 12h8M4 5h16M4 19h16"></path></svg>
          </button>

          <button
            id="align-center"
            [ngClass]="{ 'btn-active': activeTextButton === 'center' }"
            class="btn-decor"
            (click)="alignText('center')"
          >
          <svg data-v-a4392f82="" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" class="icon"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M20 19H4M20 5H4m12 7H8"></path></svg>
          </button>

          <button
            id="align-right"
            class="btn-decor"
            [ngClass]="{ 'btn-active': activeTextButton === 'right' }"
            (click)="alignText('right')"
          >
          <svg data-v-a4392f82="" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" class="icon"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M20 19H4M20 5H4m16 7h-8"></path></svg>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="mobile-float-btn">
    <div class="float-btn with-open-toolbar">
      <button
        class="floating-button"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasBottom"
        aria-controls="offcanvasBottom"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="25"
          fill="none"
          class="icon"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            d="M6 12.601h12m-6-6v12"
          ></path>
        </svg>
      </button>
    </div>
    <div
      class="offcanvas offcanvas-bottom"
      tabindex="-1"
      id="offcanvasBottom"
      aria-labelledby="offcanvasBottomLabel"
      aria-modal="true"
      role="dialog"
    >
      <div class="offcanvas-header">
        <button
          type="button"
          class="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div class="offcanvas-body small">
        <button
          (click)="addText()"
          class="btn-top-bar"
          data-bs-dismiss="offcanvas"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M12 3h4.218C19.166 3 21 5.08 21 8.026v7.948C21 18.919 19.166 21 16.217 21H7.783C4.835 21 3 18.919 3 15.974V12m5.293-2.415V8.269h7.414v1.316m-3.742-1.316v7.462m-1.618 0h3.307M4.7 2.436v4.49M6.944 4.68h-4.49"
            ></path>
          </svg>
          Text
        </button>

        <button class="btn-top-bar mt-3" data-bs-dismiss="offcanvas">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="m20.996 15.572-3.95-2.866a3.86 3.86 0 0 0-4.816.224l-7.694 6.903M3 15.474c.839-.77 2.145-1.999 3.92-1.043a28 28 0 0 1 2.174 1.316M4.7 2.436v4.49M6.944 4.68h-4.49M12.001 3h4.217C19.166 3 21 5.08 21 8.026v7.948C21 18.919 19.166 21 16.217 21H7.783C4.835 21 3 18.919 3 15.974V12"
            ></path>
          </svg>
          <label class="mb-0" for="addImage">Image</label>
          <input
            type="file"
            hidden
            (change)="addImageToCanvas($event)"
            accept="image/*"
            id="addImage"
          />
        </button>
      </div>
    </div>
  </div>
  <!-- Popup Modal for Text Editing -->
  <!-- Text Edit Popup -->
  <div
    class="text-edit-popup"
    *ngIf="canvasService.showTextEditPopup"
    id="text-edit-popup"
  >
    <div class="popup-content">
      <textarea
        id="edit-textbox"
        [(ngModel)]="canvasService.selectedTextContent"
        rows="14"
        cols="30"
        [style.text-align]="canvasService.popupTextAlign"
        placeholder="Enter your text here..."
      ></textarea>
      <div class="modal-btn-container">
        <button class="btn-save btn-text" (click)="onCancelTextEdit()">
          Cancel
        </button>
        <button class="btn-save" (click)="onSaveTextChanges()">Update</button>
      </div>
    </div>
  </div>
  <div *ngIf="showWatermarkPopup" class="watermarkpop-modal">
    <div class="watermarkpop-panel-watermark-removal">
      <!-- 🔹 Popup Header -->
      <div class="watermarkpop-top-part">
        <button
          class="watermarkpop-close-button"
          (click)="closeWatermarkPopup()"
        >
          <svg
            data-v-a91c033d=""
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            preserveAspectRatio="xMidYMid"
            viewBox="0 0 24 24"
            class="icon"
            width="18px"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="m6 6.4 12 12m0-12-12 12"
            ></path>
          </svg>
        </button>
        <div class="watermarkpop-preview-template-container portrait">
          <div
            class="watermarkpop-canvas-container watermarkpop-template-preview"
          >
            <img class="watermarkpop-preview-image" [src]="canvasImage" />
            <div class="panel-watermark-logo-image">
              <div class="watermark-magnify">
                <img
                  src="/assets/images/247invites-logo-vertical.png"
                  style="width: 34px"
                />
              </div>
              <div class="remove-watermark-icon">
                <svg
                  data-v-a91c033d
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  fill="none"
                  class="watermark-magnify-trashcan"
                >
                  <rect
                    width="22.5"
                    height="22.5"
                    x=".75"
                    y="1.703"
                    fill="#e3286a"
                    rx="11.25"
                  ></rect>
                  <rect
                    width="22.5"
                    height="22.5"
                    x=".75"
                    y="1.703"
                    stroke="#fff"
                    stroke-width="1.5"
                    rx="11.25"
                  ></rect>
                  <path
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m15.732 11.58-.343 4.69a1.857 1.857 0 0 1-1.852 1.722H10.18a1.86 1.86 0 0 1-1.853-1.722l-.342-4.69m8.501-1.762H7.23m6.74 0L13.69 8.43a.7.7 0 0 0-.675-.518h-2.308a.7.7 0 0 0-.678.518l-.28 1.387m1.048 3.013v2.524m1.893-2.524v2.524"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 🔹 Popup Content -->
      <div class="watermarkpop-main-part">
        <h4 class="watermarkpop-title">
          Would you like to remove the watermark from your design?
        </h4>
        <button
          class="watermarkpop-gi-button watermarkpop-btn-purple-premium w-full mb-2"
          (click)="removeWatermark()"
        >
          Remove watermark
        </button>
        <button
          class="watermarkpop-gi-button watermarkpop-btn-white w-full"
          (click)="downloadFree()"
        >
          Download for free
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="showWatermarkPopup" class="modal-background"></div>
</div>

<!--Last Update 060225-->
